(function () {
  const config = window.nraMetaConfig || {};
  if (typeof fbq !== 'function' || !config.pixelId) return;

  function formatContentId(variantId, productId) {
    const variant = String(variantId);
    if (config.contentIdFormat === 'shopify_us' && productId) {
      return `shopify_US_${productId}_${variant}`;
    }
    return variant;
  }

  function variantById(id) {
    const variants = window.nraMetaProduct?.variants || [];
    return variants.find((variant) => String(variant.id) === String(id));
  }

  function contentPayload(variantId, productId, quantity, unitPrice, title) {
    const id = formatContentId(variantId, productId);
    const qty = Number(quantity) || 1;
    const price = Number(unitPrice) || 0;

    return {
      content_ids: [id],
      contents: [{ id, quantity: qty }],
      content_type: 'product',
      content_name: title || window.nraMetaProduct?.title || '',
      currency: window.nraMetaProduct?.currency || window.nraMetaCart?.currency || config.currency || 'USD',
      value: price * qty,
      num_items: qty,
    };
  }

  function trackViewContent(variantId, productId) {
    if (!config.trackViewContent) return;

    const variant = variantById(variantId);
    const resolvedProductId = productId || window.nraMetaProduct?.productId;
    const price = variant?.price || 0;

    fbq(
      'track',
      'ViewContent',
      contentPayload(variantId, resolvedProductId, 1, price, window.nraMetaProduct?.title)
    );
  }

  function trackAddToCart(variantId, productId, quantity, unitPrice, title) {
    if (!config.trackAddToCart) return;

    fbq(
      'track',
      'AddToCart',
      contentPayload(
        variantId,
        productId || window.nraMetaProduct?.productId,
        quantity,
        unitPrice,
        title || window.nraMetaProduct?.title
      )
    );
  }

  function trackInitiateCheckout(cartOverride) {
    if (!config.trackInitiateCheckout) return;

    const cart = cartOverride || window.nraMetaCart;
    if (!cart?.contents?.length) return;

    fbq('track', 'InitiateCheckout', {
      content_ids: cart.contents.map((item) => formatContentId(item.id, item.productId)),
      contents: cart.contents.map((item) => ({
        id: formatContentId(item.id, item.productId),
        quantity: Number(item.quantity) || 1,
      })),
      content_type: 'product',
      currency: cart.currency || config.currency || 'USD',
      value: Number(cart.value) || 0,
      num_items: cart.contents.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0),
    });
  }

  function getSelectedVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input?.value;
  }

  function linePriceFromCartItem(item) {
    if (item?.final_price != null) return Number(item.final_price) / 100;
    if (item?.price != null) return Number(item.price) / 100;
    if (item?.item_price != null) return Number(item.item_price);
    return 0;
  }

  function cartPayloadFromAjax(cartData) {
    if (!cartData?.items?.length) return null;

    return {
      currency: cartData.currency || config.currency || 'USD',
      value: Number(cartData.total_price || 0) / 100,
      contents: cartData.items.map((item) => ({
        id: item.variant_id || item.id,
        productId: item.product_id,
        quantity: item.quantity,
        item_price: linePriceFromCartItem(item),
      })),
    };
  }

  function initProductTracking() {
    const product = window.nraMetaProduct;
    if (!product?.variants?.length) return;

    const initialVariantId = getSelectedVariantId() || String(product.variants[0].id);
    trackViewContent(initialVariantId, product.productId);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
        requestAnimationFrame(() => {
          const variantId = getSelectedVariantId();
          if (variantId) trackViewContent(variantId, product.productId);
        });
      });
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    productForm?.querySelector('[name="id"]')?.addEventListener('change', (event) => {
      trackViewContent(event.target.value, product.productId);
    });
  }

  function initCartTracking() {
    if (window.nraMetaCart) trackInitiateCheckout();
  }

  function initAddToCartTracking() {
    if (!config.trackAddToCart) return;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
        if (!data?.productVariantId || data?.source === 'cart-items') return;

        const variantId = data.productVariantId;
        const quantity = Number(data.cartData?.quantity) || 1;
        let unitPrice = variantById(variantId)?.price;

        const addedItem = data.cartData?.items?.find(
          (item) => String(item.variant_id || item.id) === String(variantId)
        );
        if (addedItem) unitPrice = linePriceFromCartItem(addedItem);

        trackAddToCart(variantId, window.nraMetaProduct?.productId, quantity, unitPrice || 0);

        const cartPayload = cartPayloadFromAjax(data.cartData);
        if (cartPayload) window.nraMetaCart = cartPayload;
      });
    }

    const originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function nraMetaFetch(input, init) {
      const url = typeof input === 'string' ? input : input?.url || '';
      const isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

      return originalFetch.apply(this, arguments).then((response) => {
        if (!isCartAdd || !response?.ok) return response;

        response
          .clone()
          .json()
          .then((payload) => {
            if (payload?.status) return;

            const variantId = payload?.variant_id || payload?.id;
            if (!variantId) return;

            const quantity = Number(payload?.quantity) || 1;
            const unitPrice = linePriceFromCartItem(payload);
            trackAddToCart(variantId, payload?.product_id, quantity, unitPrice || 0);

            const cartPayload = cartPayloadFromAjax(payload);
            if (cartPayload) window.nraMetaCart = cartPayload;
          })
          .catch(() => {});

        return response;
      });
    };
  }

  function initCheckoutClickTracking() {
    if (!config.trackInitiateCheckout) return;

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target.closest('a[href*="/checkout"], button[name="checkout"], .cart__checkout-button, .cart-drawer__checkout');
        if (!target) return;

        if (window.nraMetaCart) {
          trackInitiateCheckout();
          return;
        }

        fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .then((cartData) => {
            const payload = cartPayloadFromAjax(cartData);
            if (payload) trackInitiateCheckout(payload);
          })
          .catch(() => {});
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductTracking();
    initCartTracking();
    initAddToCartTracking();
    initCheckoutClickTracking();
  });
})();
